import { useTranslation } from "react-i18next";
import { cn } from "../../../../../lib/utils";

type MenuProps = {
    options: string[];
    option: string;
    setOption: (value: string) => void;
}

function Menu({ options, option: activeOption, setOption }: MenuProps) {
    const { t } = useTranslation();

    return (
        <div className="tw-flex tw-border-b tw-border-border tw-mb-6 tw-flex-wrap">
            {options.map((option) => (
                <button
                    key={option}
                    type="button"
                    onClick={() => setOption(option)}
                    className={cn(
                        "tw-px-4 tw-py-2 tw-cursor-pointer tw-text-xs tw-font-medium -tw-mb-px tw-border-b-2 tw-transition-colors",
                        activeOption === option
                            ? "tw-border-primary tw-text-primary"
                            : "tw-border-transparent tw-text-muted-foreground hover:tw-text-foreground"
                    )}
                >
                    {t(option)}
                </button>
            ))}
        </div>
    );
}

export default Menu;
